function RightBarMethod(label, key, icon, children,url) {
  return {key, icon, children, label, url};
}

export default RightBarMethod;
